import { apiGet } from "../../api/apiClient";

class MobileCtaActions {
  static getMobileCta = async (locationId) => {
    return await apiGet(`locations/${locationId}/textmedata`);
  };
}

export default MobileCtaActions;
